export default __webpack_public_path__ + "static/media/banner.83e72f87.png";